import { useState } from "react";
import { createPortal } from "react-dom";

export default function FixedPage({
  children,
  onOutsideClick,
  fullScreen = false,
  className,
}: {
  children: React.ReactNode;
  onOutsideClick?: () => void;
  fullScreen?: boolean;
  className?: string;
}) {
  const [isOpen, setIsOpen] = useState(true);
  
  const overlay = (
    <div
      id="fixed-page-overlay"
      className={`fixed flex items-center justify-center bg-PrimaryBlack bg-opacity-50 ${
        fullScreen
          ? "inset-0 z-[1400] overflow-hidden"
          : "left-0 right-0 top-16 bottom-16 z-50"
      } ${className}`}
      onClick={() => {
        onOutsideClick?.();
        setIsOpen(false);
      }}
    >
      {children}
    </div>
  );

  // When fullScreen is true, render to document.body to ensure it's relative to viewport
  if (fullScreen) {
    return createPortal(overlay, document.body);
  }

  return overlay;
}
